import { init as initHover } from './hover';
import { init as initScrollTop } from './scroll-top';
import { init as initFacetsBar } from './facets-bar';
import { init as initSwatch } from './swatch';
import { init as initCategoriesSlider } from './collection-categories-slider';
import { init as initPromoTiles } from './promo-tiles'; // TODELETE_OLD_PROMOTILES: this line to remove after moving to promo-tiles-slider
import { init as initPromoTilesSlider } from './promo-tiles-slider';
import { init as initPromoTilesSlots } from './promo-tiles-slots';
import { init as initInfiniteScroll } from './infinite-scroll';
import { init as initMoreToExplore } from '../home/more-to-explore';
import './facets';
import { init as initNostoSearchFix } from './nosto-search-fix';
// Re-initialize only specific scripts when needed
export const initCollectionScripts = async ()=>{
    const logErrors = (err)=>{
        console.error(err);
    };
    await initHover().catch(logErrors);
    await initSwatch().catch(logErrors);
    await initPromoTiles().catch(logErrors);
    await initPromoTilesSlider().catch(logErrors);
    await initPromoTilesSlots().catch(logErrors);
};
// Initialize everything on first load
const initAll = async ()=>{
    const logErrors = (err)=>{
        console.error(err);
    };
    await initHover().catch(logErrors);
    await initScrollTop().catch(logErrors);
    await initFacetsBar().catch(logErrors);
    await initSwatch().catch(logErrors);
    await initCategoriesSlider().catch(logErrors);
    await initPromoTiles().catch(logErrors) // TODELETE_OLD_PROMOTILES: this line to remove after moving to promo-tiles-slider
    ;
    await initPromoTilesSlider().catch(logErrors);
    await initPromoTilesSlots().catch(logErrors);
    await initInfiniteScroll(initCollectionScripts).catch(logErrors);
    await initNostoSearchFix().catch(logErrors);
    await initMoreToExplore().catch(logErrors);
};
// Run all scripts once on initial load
initAll();
